import type { ComponentProps, FC } from "react";

import { cn } from "@/lib/utils";
import { Field, FieldDescription, FieldError, FieldLabel } from "@recobra/ui/field";
import { Input } from "@recobra/ui/input";

import { getErrorMessage, useFieldContext } from "./context";

export const OptionalTextField: FC<{
  label: string;
  id?: string;
  placeholder?: string;
  colSpan?: 1 | 2;
  className?: string;
  hint?: string;
  required?: boolean;
  disabled?: boolean;
  type?: ComponentProps<typeof Input>["type"];
  inputMode?: ComponentProps<typeof Input>["inputMode"];
  maxLength?: number;
}> = ({
  label,
  id,
  placeholder,
  colSpan,
  className,
  hint,
  required,
  disabled,
  type,
  inputMode,
  maxLength,
}) => {
  const field = useFieldContext<string | undefined>();
  const errorMessage = disabled ? undefined : getErrorMessage(field.state.meta.errors[0]);

  return (
    <Field
      data-invalid={errorMessage ? "true" : undefined}
      data-disabled={disabled ? "true" : undefined}
      className={cn(colSpan === 2 ? "col-span-2" : "min-w-0", className)}
    >
      <FieldLabel htmlFor={id}>
        {label}
        {required && <span className="text-destructive">*</span>}
      </FieldLabel>
      <Input
        id={id}
        type={type}
        aria-required={required}
        placeholder={placeholder}
        value={field.state.value ?? ""}
        onChange={(e) => field.handleChange(e.target.value || undefined)}
        onBlur={field.handleBlur}
        inputMode={inputMode}
        maxLength={maxLength}
        disabled={disabled}
        aria-invalid={Boolean(errorMessage)}
      />
      {hint ? <FieldDescription>{hint}</FieldDescription> : null}
      {errorMessage ? <FieldError>{errorMessage}</FieldError> : null}
    </Field>
  );
};
